import male from "../assets/male.png";
import female from "../assets/female.png";

export const Avatar = (sex: any) => {
  switch (sex) {
    case "Male":
      return male;
    case "Female":
      return female;

    default:
      return male;
  }
};
